/* Kōzu — comportements communs : apparitions au défilement, révélation mot par mot */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Apparitions [data-ag-reveal]
  const reveal = (root = document) => {
    const els = root.querySelectorAll('[data-ag-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(e => io.observe(e));
  };

  // 2. Révélation mot par mot liée au défilement [data-ag-words]
  const words = (root = document) => {
    root.querySelectorAll('[data-ag-words]').forEach(block => {
      if (block.dataset.agReady) return; block.dataset.agReady = '1';
      const spans = block.querySelectorAll('.ag-w');
      if (reduce) { spans.forEach(s => s.classList.add('is-on')); return; }
      const update = () => {
        const r = block.getBoundingClientRect(), vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        const n = Math.round(p * spans.length);
        spans.forEach((s, i) => s.classList.toggle('is-on', i < n));
      };
      // Calcul limité à 1 par image pour un défilement sans à-coups
      let ticking = false;
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; update(); }); } };
      update(); window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    });
  };

  const init = (root) => { reveal(root); words(root); };
  document.addEventListener('DOMContentLoaded', () => init(document));
  // Éditeur de thème Shopify : ré-initialiser une section rechargée
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
